import { render } from "./Theme1.vue?vue&type=template&id=548ae4f4"
import script from "./Theme1.vue?vue&type=script&lang=js"
export * from "./Theme1.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\iconblocks\\wp-cms-fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__